import { useEffect, useState } from "react"
import type { SelectOptionType, SuccessFetch } from "types"
import { useApi } from "utils"

export function useLocation() {
  const api = useApi()
  const [dataLocation, setData] = useState<SelectOptionType[]>([])
  const [isLoadingLocation, setLoading] = useState(true)

  useEffect(() => {
    api.get("/location/")
    .then((res: SuccessFetch<{
      payload: {
        location_id: string
        location_name: string }[]
    }>) => { setData(res.data.payload.map(item => { return { label: item.location_name, value: item.location_id }}))})
    .catch(() => setData([]))
    .finally(() => setLoading(false))
  
    return () => {
      setData([])
      setLoading(true)
    }

    // eslint-disable-next-line
  }, [])

  return { dataLocation, isLoadingLocation }
}